import ajax from '../ajax'

// /api/report/operation
export function OperationApi(params) {
    return ajax({
        method:'get',
        url: '/api/report/operation',
        params
    })
}



// WEBPACK FOOTER //
// ./src/api/echarts/index.js